import { IoMdClose } from "react-icons/io";
import { FaRegFile } from "react-icons/fa";
import { useTranslation } from "react-i18next";

function SchoolAtachments() {
  const { i18n, t } = useTranslation();

  return (
    <div
      id="SchoolAtachments"
      className="font-ar max-w-[717px] w-[calc(60vw)] flex mobile:ml-0 bg-white mobile:h-[179px] mobile:px-4 rounded-lg mobile:shadow-none mobile:w-[calc(100vw-32px)] mobile:mr-0 items-center content-center justify-center drop-shadow-[0_0px_20px_rgba(0,0,0,0.05)]"
    >
      <div className="w-[425px] h-[151px] mt-8 mobile:mt-0 ">
        <p className="mb-4 mobile:mb-2 mobile:text-mint-500 mobile:text-xl mobile:font-medium">
          {t("schoolAtachments.container.attachment")}
        </p>

        <p className="font-ar text-zinc-700 text-xl	font-medium mb-2">
          {t("schoolAtachments.container.commercialRegistration")}
        </p>
        <div className="relative">
          <div
            className={`${
              i18n.language === "ar" ? "right-0 mr-4" : "left-0 ml-4"
            } w-[179px] h-[39px] bg-zinc-100 rounded-md absolute inset-y-0 px-4 py-2 mt-3 mb-3`}
          >
            <div
              className={`${
                i18n.language === "ar" ? "flex-row" : "flex-row-reverse"
              } flex gap-2 items-start justify-start`}
            >
              <div
                className={`${
                  i18n.language === "ar" ? "flex-row" : "flex-row-reverse"
                } flex flex-row justify-end w-[179px] h-[39px]`}
              >
                <button type="button" disabled={true} className="flex flex-row">
                  <IoMdClose className="text-zinc-400 mt-0.5 absolute right-2" />
                </button>
                <p className="flex text-zinc-500">File.pdf</p>
              </div>

              <FaRegFile className=" text-zinc-500 mt-0.5" />
            </div>
          </div>
          <input
            id="dropdown-input"
            type="text"
            readOnly
            disabled={true}
            className="w-full h-[61px] px-3 py-2 rounded-2xl bg-white border-zinc-400 border "
          />
        </div>
      </div>
    </div>
  );
}

export default SchoolAtachments;
